/*
 export class SomeScreenComponent class implements ApplicationScreen
    pageTitle: string = "Static Page Title"
    
    pageTitle = new FormControl('Dynamic Page Title');
    this.pageTitle.setValue('Changed Page Title');
    
    // dirty navigation protection via override getter (must also override setter)
    get isDirty(): boolean { return ? };
    set isDirty(value: boolean) { };
    // dirty navigation protection via explicitly set base class
    this.isDirty = true / false;
    
    screenMenuItems: ScreenContextMenuItem[] = [
        {
            label: '..',
            icon: '..',
            handler: () => {
                
            },
            condition: isDevMode()
        },
    ]

    // handle scanner inputs with no input element required / focused
    // handler function will receive a string or JSON object if the scanned value can be parsed as JSON
    this.onScannerInput.subscribe(fnScannerInputHandler);
    this.onScannerInput.unsubscribe();
 */

import { Component, HostListener, isDevMode } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { ComponentCanDeactivate, PendingChangesGuard } from '../services/dirty-nav-guard';

@Component({ template: '' })
export abstract class ApplicationScreen implements ComponentCanDeactivate {
    pageTitle: FormControl | string = "(pageTitle undefined)";
    isDevMode: boolean = isDevMode();
    screenMenuItems?: ScreenContextMenuItem[];

    // #region Dirty Nav Protection
    private _isDirty: boolean = false;
    public get isDirty(): boolean { return this._isDirty; }
    public set isDirty(value: boolean) { this._isDirty = value; }

    /// https://stackoverflow.com/questions/35922071/warn-user-of-unsaved-changes-before-leaving-page
    // @HostListener allows us to also guard against browser refresh, close, etc.
    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        if (PendingChangesGuard.DirtyNavProtectionDisabled) return true;
        return (!this.isDirty);
    }
    // #endregion

    // #region No-Input Scanner Receiver

    /** event emitter for when keyboard input is received directly to the document
     * (as when a barcode scanner 'types' a value where there is no focused input) */
    onScannerInput = new Subject<string | object>();

    // handle Ctrl+V (Paste) values
    @HostListener('document:keydown', ['$event'])
    documentKeyDownHandler(event: KeyboardEvent) {
        if (event.code == 'KeyV' && event.ctrlKey) {
            navigator.clipboard.readText()
                .then(data => this.emitScannerInput(data))
                .catch(err => {
                    console.error('Failed to read clipboard contents', err);
                })
        }
    }

    // receive scanned keys into a storage string or emit the scanned value when [Enter] is pressed
    private _scanBuffer: string = '';
    @HostListener('document:keypress', ['$event'])
    documentKeyPressEvent(event: KeyboardEvent) {
        let key = event.key;
        if (key === 'Enter') {
            this.emitScannerInput(this._scanBuffer);
            this._scanBuffer = '';
            event.preventDefault();
            event.stopPropagation();
        } else {
            this._scanBuffer += key;
        }
    }

    // emit the value to subscribers converting data detected as JSON data as a parsed object
    private emitScannerInput(data: string) {
        if (data.length == 0) return;

        var emit: string | object = data;
        // parse JSON barcodes into objects
        if (data.substring(0, 1) == "{" && data.substring(data.length - 1) == "}") {
            try {
                emit = JSON.parse(data);
            }
            catch { }
        }
        this.onScannerInput.next(emit)
    }
    // #endregion
}

export interface ScreenContextMenuItem {
    break?: boolean,
    condition?: boolean | (() => boolean),
    icon?: string | null,
    iconOutlined?: boolean,
    label: string,
    handler: () => void
}